import React, { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./MediaRecord.css";
import socketManager from "../socketManager/SocketManager";
import useWebRTC from "../WebrtcConnection/useWebrtc.js";
import axios from "axios";
import Micon from "../assets/Micon";
import MicOff from "../assets/MicOff";
import SwitchCamera from "../assets/SwitchCamera";
import { thirdPartServerUrl } from "../config/keys";
import ReactLoading from "react-loading";
import { asyncStorage } from "./asyncStorage.js";

// const CHUNK_SIZE = 10 * 1024 * 1024; // 10 MB chunks
// const RECORDING_DURATION = 60 * 10000; // 1 minute

// Create an Axios instance
const noBaseUrlInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor to prepend the base URL and manage headers
noBaseUrlInstance.interceptors.request.use((config) => {
  config.url = thirdPartServerUrl + config.url;
  config.headers = {
    ...config.headers,
  };
  return config;
});

let Count = 0;

const MediaRecord = () => {
  const [recording, setRecording] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  // const [facingMode, setFacingMode] = useState("user");
  const [userList, setUserList] = useState([]);
  const [previousSended, setPreviousSended] = useState([]);
  const [localStream, setLocalStream] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const localVideoRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const totalChunksRef = useRef(0);
  const chunkIndexRef = useRef(0);
  const stopUploadRef = useRef(false);
  const streamRef = useRef(null);
  const peerConnections = useRef({});
  const { artistId, contentId, mainroomname, isAudio, isFlip } = useParams();
  const navigate = useNavigate();
  const filenameRef = useRef(
    `recording_${Math.random().toString(36).substring(2, 15)}`
  ); // Generate a unique filename only once
  const [isSwitching, setIsSwitching] = useState(false);

  const isEnableAudio = isAudio === "true" ? true : false;
  const isEnableFlip = true;

  const [mute, setMute] = useState(isEnableAudio);
  const [isBack, setIsBack] = useState(isEnableFlip);
  const [videoNo, setVideoNo] = useState(0);
  const [hideSwitch, setHideSwitch] = useState(false);
  const chunkQueue = useRef([]);
  const [endLoading, setEndLoading] = useState(false);
  const [currentMic, setCurrentMic] = useState("");
  const [audioDevices, setAudioDevices] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const isStreamStrart = artistId && mainroomname;
  const [headsetMic, SetHeadsetMic] = useState(undefined);
  const [selectedMic, SetSelectedMic] = useState(undefined);

  const {
    handleSignalingData,
    createPeerConnectionCreator,
    // toggleAudio,
    closeAllPeerConnections,
  } = useWebRTC();

  const handleJoinedRoom = useCallback(
    async (userId) => {
      let retryCountA = 0;
      if (localStream && mainroomname) {
        //TODO socket for loader true
        const retryData = {
          msg: "Connecting...",
          isLoader: true,
          socketId: userId,
        };
        socketManager.retryLoader(retryData);
        await createPeerConnectionCreator(
          localStream,
          userId,
          mainroomname,
          peerConnections,
          retryCountA
        );
      }
    },
    [createPeerConnectionCreator, localStream, mainroomname]
  );

  const handleReceviedAnswer = useCallback(
    async (userId, answer, liveRoom) => {
      if (mainroomname && liveRoom && mainroomname === liveRoom) {
        await handleSignalingData({
          userId,
          answer,
          type: "answer",
          peerConnections,
        });
      }
    },
    [handleSignalingData, mainroomname]
  );

  const handleReceviedCandidate = useCallback(
    async (userId, candidate, liveRoom) => {
      if (mainroomname && liveRoom && mainroomname === liveRoom) {
        await handleSignalingData({
          userId,
          candidate,
          type: "icecandidate",
          peerConnections,
        });
      }
    },
    [handleSignalingData, mainroomname]
  );

  const handleOnline = () => {
    setIsOnline(true);
    window.location.reload();
  };

  const handleOffline = () => {
    setIsOnline(false);
  };

  useEffect(() => {
    // Listen for online and offline events
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  console.log("isOnline", isOnline);

  const handlegoLiveOffer = useCallback(
    async (data) => {
      // setMute(data?.isAudio);
      // setIsBack(data?.isFlip);
      let retryCountB = 0;
      if (data?.userList.length > 0) {
        data?.userList.forEach(async (user) => {
          if (
            user?.mainRoom === data?.mainRoom &&
            data?.createrId !== user?.userSocketId
          ) {
            //TODO socket for loader true
            const retryData = {
              msg: "Connecting...",
              isLoader: true,
              socketId: user?.userSocketId,
            };
            socketManager.retryLoader(retryData);
            await createPeerConnectionCreator(
              localStream,
              user?.userSocketId,
              mainroomname,
              peerConnections,
              retryCountB
            );
          }
        });
      }
    },
    [createPeerConnectionCreator, localStream, mainroomname]
  );

  const handleUserUpdateList = useCallback((mainUserList) => {
    // console.log("main user list ", mainUserList);
    // setUserList(mainUserList)
  }, []);

  const handleLiveUserUpdateList = useCallback((mainUserList, isBefore) => {
    if (isBefore) {
      setUserList(mainUserList);
    }
  }, []);

  const handleAudio = useCallback(() => {
    if (localStream) {
      if (mute) {
        // Mute: Replace the audio track with a silent track
        toggleAudio(true, localStream);
      } else {
        // Unmute: Restore the original audio track
        toggleAudio(false, localStream);
      }
      setMute((prevMute) => !prevMute); // Update mute state
    } else {
      console.log("Mute toggle failed: No local stream available");
    }
  }, [localStream, mute]);

  // Function to toggle audio (mute/unmute)
  const toggleAudio = (isMuted, stream) => {
    const audioTracks = stream.getAudioTracks();
    if (audioTracks.length > 0) {
      audioTracks[0].enabled = !isMuted; // Disable or enable the audio track
    }
  };

  // Function to handle chunk upload
  const uploadChunk = useCallback(
    async (chunk, index, filename, totalChunks, camType, isSilent) => {
      if (stopUploadRef.current) return;

      console.log(index, "Uploading chunk", isSilent);

      const formData = new FormData();
      formData.append("video", chunk); // Upload blob directly
      formData.append("filename", filename);
      formData.append("chunkNumber", index); // Chunk index
      formData.append("contentTd", contentId); // Add contentId for backend reference
      formData.append("totalChunks", totalChunks); // Total number of chunks
      formData.append("camType", camType);

      try {
        const response = await axios.post("/api/upload-chunk", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (response?.data?.success) {
          console.log(`Chunk ${index} uploaded successfully`, response.data);
        } else {
          console.warn(`Chunk ${index} upload failed or duplicate`);
        }
      } catch (error) {
        console.error("Upload error:", error);
      }
    },
    [contentId]
  );

  // Function to process the chunk queue
  const processQueue = useCallback(async () => {
    console.log(
      "Processing chunk queue...",
      chunkQueue.current.length,
      "stopUploadRef.current",
      stopUploadRef.current
    );
    if (chunkQueue.current.length === 0 || stopUploadRef.current) return;

    const { chunk, index, filename, totalChunks, camType, isSilent } =
      chunkQueue.current.shift();

    await uploadChunk(chunk, index, filename, totalChunks, camType, isSilent);

    if (chunkQueue.current.length > 0) {
      processQueue();
    }
  }, [uploadChunk]);

  // Start recording video chunks
  const startRecording = useCallback(
    async (stream, filename, camType) => {
      if (!stream) return;

      // const mimeType = MediaRecorder.isTypeSupported("video/webm; codecs=vp9")
      //   ? "video/webm; codecs=vp9"
      //   : "video/mp4";

      const mimeType = MediaRecorder.isTypeSupported("video/mp4")
        ? "video/mp4"
        : "video/webm; codecs=vp8"; // Fallback for Android

      let chunkCounter = 0; // Track chunk index
      let totalChunks = 0; // Track total chunks recorded

      if (chunkCounter === 0) {
        try {
          const url = `/v1/content/getVideoCount?contentId=${contentId}`;
          const res = await noBaseUrlInstance.get(url);
          chunkCounter = res.data.data;
        } catch (err) {
          console.log("error in getting chunk counter", err);
        }
      }

      const recordChunk = () => {
        const options = { mimeType, videoBitsPerSecond: 2_000_000 }; // 2 Mbps bitrate
        const recorder = new MediaRecorder(stream, options);
        // const recorder = new MediaRecorder(stream, { mimeType });
        let recordedChunks = []; // Store chunks for the session

        recorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            recordedChunks.push(event.data);
          }
        };

        recorder.onstop = () => {
          const isSilentChunk = !stream.getAudioTracks()[0].enabled;
          const blob = new Blob(recordedChunks, { type: mimeType });

          chunkCounter++;
          totalChunks++;

          const chunkData = {
            chunk: blob,
            index: chunkCounter,
            filename,
            totalChunks,
            camType,
            isSilent: isSilentChunk,
          };
          chunkQueue.current.push(chunkData);
          processQueue();
        };

        recorder.start();
        setTimeout(() => {
          recorder.stop();
          recordChunk();
        }, 10000);
      };

      recordChunk();
    },
    [processQueue]
  );

  const startStreamAndRecord = useCallback(async () => {
    console.log("Starting stream and recording...");

    try {
      console.log("Inside try block...");

      if (!navigator.mediaDevices?.enumerateDevices) {
        navigate("/not-supported", {
          state: { data: "Browser not supported" },
        });
        return;
      }

      await navigator.mediaDevices.getUserMedia({
        video: false,
        audio: true,
      });

      const devices = await navigator.mediaDevices.enumerateDevices();
      if (!devices.length) {
        navigate("/not-supported", { state: { data: "No device found" } });
        return;
      }

      console.log("AFter Length----", devices);
      setAudioDevices(devices);

      const audioDevices = devices.filter(
        (device) => device.kind === "audioinput"
      );

      console.log("Devices:", audioDevices);

      const headsetMic = audioDevices.find((device) =>
        ["headset", "earphone", "bluetooth", "external"].some((keyword) =>
          device.label.toLowerCase().includes(keyword)
        )
      );

      console.log("headsetMic--------", headsetMic);
      SetHeadsetMic(headsetMic);
      // Fallback to built-in microphone
      const defaultMic = audioDevices[0];

      const selectedMic = headsetMic || defaultMic;

      console.log("selectedMic--------", selectedMic);
      SetSelectedMic(selectedMic);
      setSelectedDevice(selectedMic);
      // const selectedMic =
      //   devices.find((device) =>
      //     ["headset", "earphone", "external", "bluetooth", "usb", "mic"].some(
      //       (keyword) => device.label.toLowerCase().includes(keyword)
      //     )
      //   ) && devices.find((device) => device.kind === "audioinput");

      console.log("Selected Mic:", selectedMic);

      const constraints = {
        video: {
          width: { ideal: 960, max: 1280, min: 640 },
          height: { ideal: 540, max: 720, min: 360 },
          frameRate: { ideal: 24, max: 30, min: 20 },
          facingMode: isEnableFlip ? "environment" : "user",
        },
        audio: selectedMic
          ? {
              deviceId: { exact: selectedMic.deviceId },
              echoCancellation: true,
              noiseSuppression: false,
              autoGainControl: false,
            }
          : true,
      };

      // Stop previous stream before starting a new one
      if (streamRef.current) {
        console.log("Stopping previous stream...");
        streamRef.current.getTracks().forEach((track) => track.stop());
        streamRef.current = null;
      }

      // Add a delay before starting a new stream
      //  await new Promise((resolve) => setTimeout(resolve, 500));

      const camType = isEnableFlip ? "B" : "F";

      const newStream = await navigator.mediaDevices.getUserMedia(constraints);

      const audioTracks = newStream.getAudioTracks();
      if (audioTracks.length > 0) {
        const track = audioTracks[0];
        track.enabled = isEnableAudio;
        const micDevice = devices.find(
          (device) => device.deviceId === track.getSettings().deviceId
        );
        setCurrentMic(micDevice?.label);
      } else {
        navigate("/not-supported", { state: { data: "No audio track found" } });
      }

      totalChunksRef.current = 0;
      chunkIndexRef.current = 0;
      stopUploadRef.current = false;

      startRecording(newStream, filenameRef.current, camType);

      if (localVideoRef.current) {
        console.log("Setting video source...");
        localVideoRef.current.srcObject = null; // Reset before setting
        localVideoRef.current.srcObject = newStream;
      }

      streamRef.current = newStream;
      setLocalStream(newStream);
      socketManager.liveStreamStarted(mainroomname);
      setRecording(true);
      console.log("Streaming started successfully!");
    } catch (error) {
      console.error("Error starting stream:", error);
      let errorMessage = error.name;
      navigate("/not-supported", { state: { data: errorMessage } });
    }
  }, [isEnableAudio, isEnableFlip, mainroomname, startRecording, navigate]);

  const stopRecording = useCallback(async () => {
    setIsLoading(true);
    setEndLoading(true);
    // socketManager.onChangedEvent(true);
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state !== "inactive"
    ) {
      // mediaRecorderRef.current.requestData();
      mediaRecorderRef.current.stop();

      // mediaRecorderRef.current.ondataavailable = async (event) => {
      //   // This will handle the last emitted chunk when stopping
      //   if (event.data.size > 0) {
      //     chunkIndexRef.current += 1; // Increment chunk index for the final chunk
      //     totalChunksRef.current += 1; // Update total chunks count

      //     const chunkData = {
      //       chunk: event.data,
      //       index: chunkIndexRef.current, // Final chunk index
      //       filename: filenameRef.current,
      //       totalChunks: totalChunksRef.current, // Total chunks
      //       camType: "B",
      //     };

      //     // Push the final chunk into the queue and process it
      //     chunkQueue.current.push(chunkData);
      //     await processRemainingChunks(); // Upload remaining chunks
      //   }
      // };
    }

    closeAllPeerConnections(peerConnections);
    localStream.getTracks().forEach((track) => {
      track.stop();
    });
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
      if (localVideoRef.current) {
        localVideoRef.current.srcObject = null;
      }
    }
    // socketManager.onChangedEvent(true);
    setRecording(false);
    // stopUploadRef.current = true;

    const url = `/v1/content/updateContentStatus?id=${contentId}&eventStatus=End`;
    const eventStatus = await noBaseUrlInstance.put(url);

    console.log(eventStatus);

    if (eventStatus.status === 200) {
      socketManager.onChangedEvent(true);
      // should stay commented...
      // await axios.post("/api/chunk-merger", {
      //   filename: filenameRef.current,
      //   totalChunks: totalChunksRef.current,
      //   contentTd: contentId,
      //   chunkNumber: chunkIndexRef.current,
      //   endStream: "completed",
      // });
    }
  }, [closeAllPeerConnections, contentId, localStream]);

  const handleArtistBackPressed = useCallback(
    async (msg) => {
      if (msg && msg.length > 0) {
        await stopRecording();
      }
    },
    [stopRecording]
  );

  const handleArtistDisconnected = useCallback(async (message) => {
    socketManager.socket.disconnect();
    // navigate("/end-stream");
    setEndLoading(false);
  }, []);

  useEffect(() => {
    socketManager.newUserJoinedInMainRoom(handleJoinedRoom);
    socketManager.onUpdategoLive(handlegoLiveOffer);
    socketManager.receviedAnswer(handleReceviedAnswer);
    socketManager.receviedIceCandidate(handleReceviedCandidate);
    socketManager.onUpdatedUserList(handleUserUpdateList);
    socketManager.onUpdateLiveUserList(handleLiveUserUpdateList);
    socketManager.onArtistDisconnected(handleArtistDisconnected);
    // socketManager.updateUserDisconnected(handleUpdateUserDisconnected)
    // socketManager.createMainRoom("", artistId, true)
    socketManager.onBackPreesArtist(handleArtistBackPressed);

    return () => {
      socketManager.socket.off("update-user-list", handleUserUpdateList);
      socketManager.socket.off("newUserJoined", handleJoinedRoom);
      socketManager.socket.off("answer", handleReceviedAnswer);
      socketManager.socket.off("ice-candidate", handleReceviedCandidate);
      socketManager.socket.off("updategoLive", handlegoLiveOffer);
      socketManager.socket.off(
        "live-update-user-list",
        handleLiveUserUpdateList
      );
      socketManager.socket.off("artist-disconnected", handleArtistDisconnected);
      // socketManager.socket.off('update-user-disconnected', handleUpdateUserDisconnected);

      // webRTCManagerLive.cleanUp();
      socketManager.socket.off("onBackPressArtist", handleArtistBackPressed);
    };
  }, [
    handleJoinedRoom,
    handlegoLiveOffer,
    handleReceviedAnswer,
    handleReceviedCandidate,
    handleUserUpdateList,
    handleLiveUserUpdateList,
    handleArtistDisconnected,
    handleArtistBackPressed,
  ]);

  const handleSequentialMerge = useCallback(async () => {
    try {
      await axios.post("/api/convert-to-S3", {
        filename: filenameRef.current,
        contentTd: contentId,
        noOfVideos: videoNo,
      });
    } catch (error) {
      console.error("Error in merging videos:", error);
    }
  }, [contentId, videoNo]);

  useEffect(() => {
    if (isLoading) {
      const interval = setTimeout(async () => {
        setIsLoading(false);
        socketManager.onChangedEvent(true);

        // await handleSequentialMerge();
        setVideoNo(0);

        // socketManager.onChangedEvent(true);
        socketManager.onArtistDisconnect(mainroomname);
        // navigate("/end-stream");
      }, 2000); // 2 seconds

      // Cleanup function
      return () => clearTimeout(interval);
    }
  }, [handleSequentialMerge, isLoading, mainroomname, navigate]);

  useEffect(() => {
    if (isStreamStrart && Count === 0) {
      socketManager.createMainRoom(mainroomname, artistId, true);
      startStreamAndRecord();
      Count++;
    }
  }, []);

  useEffect(() => {
    if (localStream && userList.length > 0) {
      userList.forEach(async (user) => {
        let previousUser = previousSended.some(
          (u) => u.userSocketId === user.userSocketId
        );
        if (!previousUser) {
          setPreviousSended((previous) => [...previous, user]);
          await createPeerConnectionCreator(
            localStream,
            user.userSocketId,
            mainroomname,
            peerConnections
          );
        }
      });
    }
  }, [
    createPeerConnectionCreator,
    localStream,
    mainroomname,
    previousSended,
    userList,
  ]);

  useEffect(() => {
    if (artistId) {
      const existArtistId = asyncStorage.getItem("artistId");
      if (existArtistId) {
        if (existArtistId !== artistId) {
          asyncStorage.removeItem("artistId");
        }
      }
      asyncStorage.setItem("artistId", artistId);
    }
  }, [artistId]);

  return (
    <div className="container">
      {endLoading ? (
        <ReactLoading
          type="spinningBubbles"
          color="#BB8A01"
          height={64}
          width={64}
        />
      ) : (
        <>
          <div className="top_live_screen">
            <video
              ref={localVideoRef}
              autoPlay
              muted
              playsInline
              webkit-playsinline
              className="video"
              style={{ transform: isBack ? "scaleX(1)" : "scaleX(-1)" }}
            />
            {recording && <p className="mic-label">Mic: {currentMic}</p>}
            {/* {recording && (
              <select
                className="mic-label-2"
                value={selectedDevice?.deviceId || ""}
              >
                {audioDevices.map((device, index) => (
                  <option
                    key={`${device.deviceId}-${device.groupId || index}`}
                    value={device.deviceId}
                  >
                    {device.kind} - {device.label}
                  </option>
                ))}
              </select>
            )} */}
            {/* {recording && (
              <p className="mic-label-3">headsetMic: {headsetMic?.label}</p>
            )}
            {recording && (
              <p className="mic-label-4">selectedMic: {selectedMic?.label}</p>
            )} */}
          </div>
          {recording && (
            <div className="bottom_tabs_action">
              {mute ? (
                <button className="mic_on" onClick={handleAudio}>
                  <Micon />
                </button>
              ) : (
                <button className="mic_on" onClick={handleAudio}>
                  <MicOff />
                </button>
              )}

              <button className="end-stream" onClick={stopRecording}>
                End Live
              </button>
              {/* 
            {!hideSwitch && (
              <button className="switch_camera" onClick={handleSwitchCamera}>
                <SwitchCamera />
              </button>
            )} */}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MediaRecord;
